import React from "react";
import modalStyles from "@/styles/Modal.module.scss";
import { Button } from "../Buttons";
import { useCallback, useEffect, useState, useRef, forwardRef } from "react";
import routes from "@/lib/routes";

const ChatMessageReportStepInit = (props) => {
  // メッセージが通報済みかチェック
  const isReported = props.reportedMessageIds.includes(props.id);

  return (
    <>
      <header>
        <h3>チャット内容</h3>
      </header>
      <div className={modalStyles.chatMessageDisplay}>
        <div className={modalStyles.chatMessage}>
          <span className={modalStyles.username}>{props.displayName}</span>
          <span className={modalStyles.messageContent}>{props.postDesc}</span>
        </div>
      </div>

      <Button
        key="doReportButton"
        borderLight
        fontFixed
        fillWhiteColor
        large
        onClick={props.setStepReport}
        disabled={isReported}
      >
        {isReported ? "通報済み" : "通報する"}
      </Button>

      <Button
        key="doMuteButton"
        borderLight
        fontFixed
        fillWhiteColor
        large
        onClick={props.setStepMute}
      >
        非表示にする
      </Button>
      <Button fontFixed large borderLight onClick={props.modalCloseHandle}>
        閉じる
      </Button>
    </>
  );
};

export default ChatMessageReportStepInit;
